import * as React from 'react'
import { useContext, useEffect, useState } from 'react'

import {AppContext} from "../../../Context/AppContext"

import {postier} from "./Postier"

export function Create({ setPagina ,mesures ,setMesures }) {

    const { site, token, client, type,setType, setErrors } = useContext(AppContext)

    const [fields, setFields] = useState({ entityId: '', entityName: '', entityType: type[0]?type[0].ID:"none", description: ''});

    const [idMesure, setIdMesure] = useState<string>('')

    // const mesuresLength = mesures.length

    useEffect(() => {
        const siteId = parseInt(site.split(":")[0]);
        const typeId = parseInt(fields.entityType)<10 ? '0'+parseInt(fields.entityType) : parseInt(fields.entityType)
        let splitter = '';

        console.log({mesure : mesures[0],type:type[0],field:fields.entityType})
        // récupération du nom de la mesure pour la comparer après
        let typeName = ""
		
        for (const t of type) {
            if (t.ID === fields.entityType) {
                typeName = t.Label
            }
        }
            
        // console.log({typeName,mesures})

        // TODO : filter the right type of entity from mesures
		
		if (!typeId || typeName == ""){
            setErrors((errors: string) => [...errors, "les mesures types de ce client n'ont pas été rempli correctement"])			
			return
		}


        const mesuresLength = mesures.filter(mesure => mesure.Type === typeName).length +1

        splitter = (mesuresLength < 10 && '000') || (mesuresLength < 100 && '00') || (mesuresLength < 1000 && '0')
        // ajouter l'id du type de mesure
        const final = `${siteId}${typeId}${splitter}${mesuresLength}`;

        postier.getTypes(token, setType, setErrors)

        setIdMesure(final)
    }, [site,fields])

    const validate = () => {
        if (!fields.entityName) {
            setErrors((errors: string[]) => [...errors, 'Le nom doit être renseigné'])
            return false;
        }

        if (!fields.description) {
            setErrors((errors: string[]) => [...errors, 'La description doit être renseignée'])
            return false;
        }

        const mesure = {
            database: client.split(':')[3],
            id_site: site.split(':')[0],
            id_entity: idMesure,
            entity_name: fields.entityName.replace(/'/g, "''"),
            entity_type: fields.entityType,
            description: fields.description.replace(/'/g, "''"),
            is_monitored: '1',
            apiId: localStorage.getItem('apiId')
        }

        postier.createMesure(token, mesure, setPagina, setMesures, setErrors)
    }

    const handleChange = (field: string, e) => {
        const fieldsCopy = {...fields};
        fieldsCopy[field] = e.target.value;
        setFields(fieldsCopy);
    };

    return (
        <div className="form">
            <h2>Création mesure</h2>
                <label>Code Client</label>
                <label className="label"> { client.split(":")[0] }</label>

                <label>ID Site</label>
                <label className="label"> { site.split(':')[0] }</label>

                <label>Entity ID</label>
                <label className="label"> { idMesure }</label>

                <label>Nom</label>
                <input className="label" onChange={e => handleChange('entityName', e)} />

                <label>Type d'entité </label>
                <select onChange={(e) => handleChange('entityType', e)} defaultValue={fields.entityType}>
                    {type.map((t) =>
                        <option key={t.ID} value={t.ID}>
                            {t.Label}
                        </option>
                    )}
                </select>

                <label>Description </label>
                <textarea className="label" onChange={e => handleChange('description', e)} />

            <button onClick={validate} >Enregistrer</button>
        </div>
    )
}
